<template>
<div class="container sales-record-details-wrapper">
    <div v-if="type == 'sales'">
        <div class="ba-sales-wrapper" v-for="(thisSales, index) in salesData" v-bind:key="index">
            <h6>{{thisSales.ba_name}}</h6>
            <div class="table-scroll">
                <table>
                    <thead>
                        <tr>
                            <th class="title-sku sticky-cell">SKU</th>
                            <th class="title-total sticky-cell">Total</th>
                            <th v-for="(location, locationIndex) in thisSales.venues" v-bind:key="locationIndex">{{location.text}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product, productIndex) in thisSales.products" v-bind:key="productIndex">
                            <td class="title-sku sticky-cell">{{product.name}}</td>
                            <td class="title-total sticky-cell">{{product.product_total_quantity}} <span v-if="product.product_total_quantity > 0">Packs</span><br>RM{{formatPrice(product.product_total_price, '', 0)}}</td>
                            <td v-for="(venueDetail, venueDetailIndex) in product.venueDetail" v-bind:key="venueDetailIndex">{{venueDetail.quantity}} <span v-if="venueDetail.quantity > 0">Packs</span><br>RM{{formatPrice(venueDetail.price, '', 0)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div v-if="type == 'trial'">
        <div class="ba-sales-wrapper" v-for="(thisTrial, index) in trialData" v-bind:key="index">
            <h6>{{thisTrial.ba_name}}</h6>
            <div class="table-scroll">
                <table>
                    <thead>
                        <tr>
                            <th class="title-sku sticky-cell">Venue</th>
                            <th>Trial Rate</th>
                            <th>Non-Trial Rate</th>
                            <th>Total Contact</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trialVenue, trialIndex) in thisTrial.venues" v-bind:key="trialIndex">
                            <td class="title-sku sticky-cell">{{trialVenue.name}}</td>
                            <td>{{trialVenue.trial_rate_number}}</td>
                            <td>{{trialVenue.non_trial_rate_number}}</td>
                            <td>{{trialVenue.total_contact}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="text-center">{{noData}}</div>

    <app-loader v-show="isLoading"></app-loader>
</div>
</template>

<script>
import { getSaleRecordDetails } from '../api'
import Loader from './Loader.vue'
// import Paginate from 'vuejs-paginate'

export default {
    components: {
        appLoader: Loader,
        // appPaginate: Paginate,
    },
    data() {
        return {
            type: this.$route.params.type,
            date: this.$route.params.date,
            userId: this.$route.params.userId,
            salesData: "",
            trialData: "",
            noData: "",
            isLoading: true,
            showingResults: "",
        }
    },
    async mounted() {
        var token = this.$route.query.token;
        await this.getSaleRecordDetails(this.type, this.date, this.userId, token);
        this.isLoading = false;
    },
    methods: {
        formatPrice(value, currency, decimals) {
            value = parseFloat(value);
            if (!isFinite(value) || (!value && value !== 0)) return '';
            currency = currency != null ? currency : '$';
            decimals = decimals != null ? decimals : 2;
            var stringified = Math.abs(value).toFixed(decimals);
            var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
            var i = _int.length % 3;
            var head = i > 0 ? (_int.slice(0, i) + (_int.length > 3 ? ',' : '')) : '';
            var _float = decimals ? stringified.slice(-1 - decimals) : '';
            var sign = value < 0 ? '-' : ''
            return sign + currency + head + _int.slice(i).replace(/(\d{3})(?=\d)/g, '$1,') + _float
        },
        async getSaleRecordDetails(type, date, userId, token) {
            try {
                const response = await getSaleRecordDetails(type, date, userId, token);
                const result = response.data;

                if(result){
                    
                    if(result.success){
                        if(result.message == 'No Record Found'){
                            this.noData = 'No Record Found';
                            console.log("No Record Found");
                        } else {
                            if(this.type == 'sales'){
                                var salesData = result.data.result;
                                for(var i=0; i<salesData.length; i++){

                                    for(var k=0; k<salesData[i].products.length; k++){
                                        var tempProducts = salesData[i].products[k];
                                        var productArr = [];

                                        for(var j=0; j<salesData[i].venues.length; j++){
                                            var tempObj = {'product_name': salesData[i].products[k].name, 'venue_name': salesData[i].venues[j].value, 'quantity': 0, 'price': 0};

                                            for(var key in tempProducts){
                                                if(key == salesData[i].venues[j].value+'_total_quantity'){
                                                    tempObj.quantity = tempProducts[key];
                                                }

                                                if(key == salesData[i].venues[j].value+'_total_price'){
                                                    tempObj.price = tempProducts[key];
                                                }
                                            }

                                            productArr.push(tempObj);
                                        }

                                        tempProducts.venueDetail = productArr;
                                    }
                                }

                                this.salesData = salesData;
                                console.log("Record Found");

                            } else if(this.type == 'trial'){
                                this.trialData = result.data.result;
                                console.log("Record Found");
                            }
                        }
                    }
                }
            }
            catch(err) {
                alert(err);
                this.noData = err;
            }
        },
        async pagination(pageNum) {

            this.isLoading = true;  
            
            if(pageNum != 0)
                this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
            else 
                pageNum = this.$refs.paginateBottom.selected;

            await this.getSaleRecordDetails(pageNum);

            this.isLoading = false;
        }
    }
}
</script>